import { Component, input } from '@angular/core';

@Component({
  selector: 'app-signing-room-dialog',
  templateUrl: './signing-room-dialog.component.html',
  styleUrls: ['./signing-room-dialog.component.scss'],
  standalone: false,
})
export class SigningRoomDialogComponent {
  dialogTitle = input.required<string>();
  message = input<string>();
}
